// These are production canonical URLs
export enum URLS {
  ROOT = 'https://www.deviantart.com',

  // the following are non-node URLs
  ABOUT = 'https://www.deviantart.com/about',
  ACCESSIBILITY_POLICY = 'https://www.deviantart.com/about/policy/accessibility',
  ADVERTISE = 'https://deviantartads.com',
  CAREERS = 'https://www.deviantart.com/team/journal/Careers-at-DeviantArt-855261915',
  CART = 'https://www.deviantart.com/checkout/',
  COMMISSIONS = 'https://www.deviantart.com/commissions',
  CONTACT = 'https://www.deviantartsupport.com/en/article/how-do-i-contact-deviantart',
  COPYRIGHT = 'https://www.deviantart.com/about/policy/copyright/',
  COPYRIGHT_POLICY = 'https://www.deviantartsupport.com/en/article/the-copyright-policy',
  CORE_MEMBERSHIP = 'https://www.deviantart.com/core-membership',
  DEVELOPERS = 'https://www.deviantart.com/developers',
  DEVELOPERS_APPS = 'https://www.deviantart.com/developers/apps',
  REGISTER_APPLICATION = 'https://www.deviantart.com/developers/register',
  DREAMUP_POLICY = 'https://www.deviantart.com/about/policy/dreamup/',
  EARNINGS = 'https://www.deviantart.com/account/earnings/',
  EARNINGS_DOWNLOAD = 'https://www.deviantart.com/account/earnings/download_csv/',
  ETIQUETTE = 'https://www.deviantart.com/about/policy/etiquette',
  FEEDBACK = 'https://www.deviantartsupport.com/en/eclipse',
  FORUM = 'https://www.deviantart.com/forum',
  GROUPS = 'https://www.deviantart.com/groups',
  GROUPS_CREATE = 'https://www.deviantart.com/groups/create',
  HELP = 'https://www.deviantartsupport.com/en',
  HELP_NEW_TICKET = 'https://contact.deviantartsupport.com/en',
  LOGOUT = 'https://www.deviantart.com/users/logout',
  MATURE_POLICY = 'https://www.deviantartsupport.com/en/article/what-is-deviantarts-policy-around-sexual-erotic-and-fetish-themes',
  MLT = 'https://www.deviantart.com/morelikethis',
  NOTES = 'https://www.deviantart.com/notifications/notes',
  OAUTH_AUTHORIZE = 'https://www.deviantart.com/oauth2/authorize',
  ORDERS = 'https://www.deviantart.com/account/',
  POINTS = 'https://www.deviantart.com/account/points/',
  ABOUT_POINTS = 'https://www.deviantartsupport.com/en/article/what-are-points-1749105',
  POINTS_POLICY = 'https://www.deviantart.com/about/policy/points/',
  POLLS = 'https://www.deviantart.com/polls',
  PRIVACY = 'https://www.deviantart.com/about/policy/privacy',
  SETTINGS = 'https://www.deviantart.com/settings/identity',
  SETTINGS_GENERAL = 'https://www.deviantart.com/settings/general',
  SETTINGS_BILLING = 'https://www.deviantart.com/settings/billing_and_payments',
  SETTINGS_REBILLING = 'https://www.deviantart.com/settings/rebilling',
  SETTINGS_PROMOS = 'https://www.deviantart.com/settings/promos',
  SETTINGS_BROWSING = 'https://www.deviantart.com/settings/browsing',
  SHOP = 'https://www.deviantart.com/shop',
  SHOP_ME = 'https://www.deviantart.com/me/shop',
  SHOP_TOP_NAV = 'https://www.deviantartsell.com/',
  STASH = 'https://sta.sh/',
  STATUS_UPDATES = 'https://www.deviantart.com/status-updates',
  SUBMISSION_POLICY = 'https://www.deviantart.com/about/policy/submission',
  SUBMIT = 'https://www.deviantart.com/submit/',
  SUPPORT = 'https://www.deviantart.com/contact-us',
  STUDIO = 'https://www.deviantart.com/studio',
  SUBMIT_MURO = 'https://www.deviantart.com/muro/',
  TAG = 'https://www.deviantart.com/tag',
  TOS = 'https://www.deviantart.com/about/policy/service',
  COOKIES = 'https://www.deviantart.com/settings/cookies',
  WATCHING = 'https://www.deviantart.com/watching/',
  CHAT_HOME = 'https://www.deviantart.com/chat',
  CDN = 'https://st.deviantart.net',
  ART_STORE = 'https://www.popup-art.shop/',
  DMCA = 'https://contact.deviantartsupport.com/en?subOptionId=I-am-the-Copyright-holder.41656',
  DMCA_COUNTER = 'https://contact.deviantartsupport.com/en?subOptionId=I%27d-like-to-file-a-counter-DMCA61640',
  CUSTOMER_DASHBOARD = 'https://www.deviantart.com/account/customers',
  CHECKOUT_ERRORS = 'https://www.deviantartsupport.com/en/article/why-am-i-getting-an-issue-notification-when-i-try-to-purchase',
  EXCLUSIVES_HOWTO = 'https://www.deviantartsupport.com/kb/en/article/how-do-i-buy-an-adoptable-or-exclusive',
  PROTECT = 'https://www.deviantartprotect.com/',
  TEAM = 'https://www.deviantart.com/team',
  COMMUNITY = 'https://www.deviantart.com/community',
  APP_PLAYSTORE_URL = 'https://play.google.com/store/apps/details?id=com.deviantart.android.damobile',
  BETA_TESTING = 'https://www.deviantart.com/team/journal/Become-a-Beta-Tester-on-DeviantArt-983449642',
  MESSAGES = 'https://www.deviantart.com/messages',

  // Social links
  DEVIANTART_INSTAGRAM = 'https://www.instagram.com/deviantart/',
  DEVIANTART_FACEBOOK = 'https://www.facebook.com/deviantart/',
  DEVIANTART_TWITTER = 'https://twitter.com/DeviantArt',
}

export enum PROJECTS {
  BROWSE = 'BROWSE',
  MESSAGECENTRE = 'MESSAGECENTRE',
  PROFILE = 'PROFILE',
  DEVIATION = 'DEVIATION',
  COMMENTS = 'COMMENTS',
  SISU = 'SISU',
  PONIES = 'PONIES',
  CHAT = 'CHAT',
  EDITOR = 'EDITOR',
  FEEDBACK = 'FEEDBACK',
  STASH = 'STASH',
}

export enum USER_PROFILE_SECTION_PATHS {
  HOME = '',
  ABOUT = 'about',
  GALLERY = 'gallery',
  SHOP = 'shop',
  FAVOURITES = 'favourites',
  PRIVATE_COLLECTIONS = 'private-collections',
  POSTS = 'posts',
  STATS = 'stats',
  SUBSCRIPTIONS = 'subscriptions',
  BACKROOM = 'backroom',
  EXCLUSIVES = 'exclusives',
}

export enum USER_PROFILE_SHOP_SUB_PATHS {
  ALL = '',
  ADOPTABLES = 'adoptables',
  EXCLUSIVES = 'exclusives',
  COMMISSIONS = 'commissions',
  PREMIUM_CONTENT = 'premium_content',
  PREMIUM_FOLDERS = 'premium_folders',
}

export enum USER_PROFILE_POSTS_SUB_PATHS {
  ALL = '',
  JOURNALS = 'journals',
  STATUSES = 'statuses',
  POLLS = 'polls',
  DRAFTS = 'drafts',
}

export enum USER_PROFILE_BACKROOM_SECTIONS {
  ROOT = '', // default
  NOTES = 'notes',
  ACTION_LOG = 'actionlog',
  MESSAGE_LOG = 'messagelog',
  ROSTER = 'roster',
}

export enum DEVIATION_PATHS {
  DEVIATION = 'art',
  JOURNAL = 'journal',
  COMMISSION = 'commission',
  STATUS = 'status-update',
  POLL = 'poll',
  TIER = 'tier',
}

export enum CONTACT_PAGE_ANCHOR_JUMP_POINTS {
  DRILLDOWN = 'drilldown',
  ISSUE_RESPONSE = 'issue-response',
  FORM = 'form',
}

export enum SHOP_PATHS {
  ADOPTABLES = 'adoptables',
  EXCLUSIVES = 'exclusives',
  DOWNLOADS = 'downloads',
  COMMISSIONS = 'commissions',
  SUBSCRIPTIONS = 'subscriptions',
}

export enum CHECKOUT_IDS {
  CAKE = 150647560,
}

export enum DEVIATION_PAGE_LANDING_ACTION {
  ADOPTABLE_BUY_IT_NOW = 'adoptable-buy-now',
  ADOPTABLE_MAKE_OFFER = 'adoptable-make-offer',
  PUBLISHED = 'published',
}
